import { render, staticRenderFns } from "./ProfessorVinculoCard.vue?vue&type=template&id=1fb92643&scoped=true"
import script from "./ProfessorVinculoCard.vue?vue&type=script&lang=js"
export * from "./ProfessorVinculoCard.vue?vue&type=script&lang=js"
import style0 from "./ProfessorVinculoCard.vue?vue&type=style&index=0&id=1fb92643&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb92643",
  null
  
)

export default component.exports